<template>
  <div class="im-file-message" :class="{ right: isMe }" @click="onDownload">
    <div class="file-icon">
      <uni-icons class="file-icon" type="paperclip" color="#5cadff" size="48" />
    </div>
    <div class="file-element">
      <span class="file-name">{{ message.payload.fileName }}</span>
      <!-- <span class="file-size">{{ message.payload.fileSize }}</span> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: Object,
      default() {
        return {
          payload: {}
        }
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    isMe() {
      return this.message.flow === 'out'
    }
  },
  methods: {
    onDownload() {
      uni.downloadFile({
        url: this.message.payload.fileUrl,
        succes({ tempFilePath, statusCode }) {
          if (statusCode === 200) {
            uni.showToast({
              title: '下载成功'
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.im-file-message {
  &.right {
    .file-icon {
      text-align: right;
    }
    .file-element {
      text-align: right;
    }
  }

  .file-name {
    word-break: break-all;
  }
}
</style>
